module.exports = __webpack_public_path__ + "static/media/stx.053e0b23.png";